import { cn } from '../../lib/cn'

interface EyebrowProps {
  children: React.ReactNode
  className?: string
  tone?: 'brand' | 'light' | 'muted' | 'accent'
  withDot?: boolean
  style?: React.CSSProperties
}

const toneClass: Record<NonNullable<EyebrowProps['tone']>, string> = {
  brand: 'text-brand-600',
  light: 'text-white/70',
  muted: 'text-ink-500',
  accent: 'accent-text',
}

export function Eyebrow({ children, className, tone = 'brand', withDot = true, style }: EyebrowProps) {
  return (
    <span className={cn('eyebrow', toneClass[tone], className)} style={style}>
      {withDot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  )
}
